<template>
<div>
    <!--  MODAL -->
      <actionmodalnarrow ref="mymodal"> 
        <template v-slot:body>
           <div class="pleasewaitdiv vertFlexStretch">
            <div></div>
             <label class="pleasewait">Please Wait...</label>
             <div></div>
           </div>
           
           
            
        </template>
      </actionmodalnarrow>
    </div>
</template>

<script>

import actionmodalnarrow from '../actions/actionmodalnarrow.vue'

export default {
    name:'pleasewaitmodal',
    components:{
        actionmodalnarrow
    },

    data(){
        return{
            
        }
    },
    computed:{

    },
    methods:{
        show(){
            this.$refs.mymodal.openModal()
        },
        hide(){
           this.$refs.mymodal.closeModal()    
        },  
    }
}
</script>

<style>
.pleasewaitdiv{
    height:120px;
    font-size: larger;
}

</style>





























